import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_PROFILE_START,
} from '../../actions/types'

import {
  updateProfileSuccess,
  updateProfileFailure,
  loanApplicationUserVerifyStart,
  loanApplicationUserVerifySuccess,
  loanApplicationUserVerifyFailure,
} from '../../actions'

import {
  putLoanApplicationUser,
  putVerifyLoanApplicationUser,
} from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
  getLoanApplicationUser,
  getResidentialHistories,
  getResidentialHistoryIds,
} from '../../reducers'

function* loanUpdateProfile({type, payload}) {
  const loanApplicationId = yield select(getLoanApplicationId);
  const loanApplicationUser = yield select(getLoanApplicationUser);
  const residentialHistories = yield select(getResidentialHistories);
  const residentialHistoryIds = yield select(getResidentialHistoryIds);

  let residential_histories = residentialHistoryIds.reduce((result, key) => {
    result[key] = {
          id: residentialHistories[key].id,
          key: key,
          years: residentialHistories[key].years,
          months: residentialHistories[key].months,
          location_attributes: {
            address: residentialHistories[key].locationAddress,
            postcode: residentialHistories[key].locationPostcode,
            suburb: residentialHistories[key].locationSuburb,
            state: residentialHistories[key].locationState,
            country: residentialHistories[key].locationCountry,
          },
          _destroy: residentialHistories[key]._destroy,
        }
    return result;
  }, {})

  const data = {
    loan_application_user: {
      user_attributes: payload.user,
      profile_attributes: payload.profile,
      residential_histories_attributes: residential_histories
    },
    current_applicant: payload.currentApplicant
  }

  if (gon.loan_application.enable_verification && loanApplicationUser.needsVerify) {
    yield put(loanApplicationUserVerifyStart())

    const { response, error } = yield call(putVerifyLoanApplicationUser, loanApplicationId, data)

    if (response) {
      yield put(loanApplicationUserVerifySuccess(response))
    } else {
      yield put(loanApplicationUserVerifyFailure({
        residentialHistories: error.response.data.residentialHistories,
        profile: error.response.data.profile,
      }))
    }
  } else {
    const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

    if (response) {
      response['currentApplicant'] = payload.currentApplicant;
      yield put(updateProfileSuccess(response))
    } else {
      yield put(updateProfileFailure({
        residentialHistories: error.response.data.residentialHistories,
        profile: error.response.data.profile,
      }))
    }
  }
}

export function* watchLoanUpdateProfile() {
  yield takeLatest(UPDATE_PROFILE_START, loanUpdateProfile)
}
